import React from 'react';
import { useSelector } from 'react-redux';
import { List } from 'immutable';

import LabelElementPillsContainer from '../../../labels/LabelElementPillsContainer';
import { selectLabelsByIds } from '../../../labels/labelSelectors';
import { length } from '../../../../../common/utils/immutableHelper';
import { TaskLabelData } from '../taskPillsTypes';

import './TaskLabelPills.scss';

const TaskLabelPills: React.FC<TaskLabelData> = ({ labelIds }) => {
    const elementLabels = useSelector(selectLabelsByIds(labelIds));
    const labelCount = length(elementLabels);

    if (!labelCount) return null;

    return (
        <div className="TaskLabelPills">
            <LabelElementPillsContainer labels={List(elementLabels)} size="xs" />
        </div>
    );
};

export default TaskLabelPills;
